import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link } from "react-router-dom";
import { baseURL } from "../redux/Action";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Footer from "../Components/v1/Footer";

const Signup = () => {
  const [social, setSocial] = useState(false);
  const [signup, setSignup] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Blogshog | Establish Protocol";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignup({
      ...signup,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const addresses = [];
    let obj = {},
      socialObj = {};
    for (let keys in signup) {
      if (["street", "city", "pincode", "state"].includes(keys)) {
        obj[keys] = signup[keys];
      } else if (["linked_in", "twitter", "instagram"].includes(keys)) {
        socialObj[keys] = signup[keys];
      }
    }
    addresses.push(obj);
    let avatar =
      signup.gender === "male" || signup.gender === "other"
        ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFHZsc3xwRGK_buY_o47OogoecMLL8W_dfjw&usqp=CAU"
        : "https://cdn.pixabay.com/photo/2017/01/30/23/52/female-2022387_960_720.png";

    const payload = {
      name: signup.name,
      email: signup.email,
      social_profile: socialObj,
      password: signup.password,
      addresses,
      gender: signup.gender,
      avatar,
    };

    const id = toast.loading("Formulating identity...", { theme: "dark" });
    axios
      .post(`${baseURL}/signup`, payload)
      .then((res) => {
        toast.update(id, {
          render: res.data,
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        navigate("/login");
      })
      .catch((err) => {
        toast.update(id, {
          render: err.response?.data?.error || "Error establishing protocol",
          type: "error",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };

  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-black text-black dark:text-white">
      <div className="flex-1 flex flex-col md:flex-row mt-[73px] bg-white dark:bg-black border-b border-black dark:border-white/30">
        {/* Left Typography Block */}
        <div className="w-full md:w-[40%] p-8 md:p-16 border-b md:border-b-0 md:border-r border-black dark:border-white/30 flex-col pt-24 bg-[#f4f4f4] dark:bg-[#0a0a0a] relative overflow-hidden hidden md:flex">
          <div className="absolute top-0 right-0 p-8 text-[15vw] md:text-[8vw] font-black leading-none text-black/5 dark:text-white/5 select-none pointer-events-none -mt-4 tracking-tighter mix-blend-multiply dark:mix-blend-normal">
            INIT
          </div>

          <div className="z-10 relative">
            <span className="inline-block border border-black dark:border-white/30 px-3 py-1 text-[10px] font-mono font-bold tracking-widest uppercase mb-8 bg-white dark:bg-[#111] text-black dark:text-white shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
              SYS.INF.04 — Origin
            </span>
            <h1 className="text-4xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.9] mb-4 text-black dark:text-white">
              ESTABLISH
              <br />
              PROTOCOL
            </h1>
            <p className="mt-8 text-xs font-mono tracking-widest leading-relaxed max-w-sm text-gray-700 dark:text-gray-300 font-bold uppercase">
              Formulate your identity within the system. Precision in data input
              guarantees structural integrity.
            </p>
          </div>
        </div>

        {/* Right Form Block */}
        <div className="w-full md:w-[60%] p-8 md:p-12 lg:p-16 bg-white dark:bg-black relative">
          <form
            onSubmit={handleSubmit}
            className="w-full max-w-2xl mx-auto relative z-10 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6"
          >
            <div className="md:col-span-2 text-xs font-mono font-black uppercase tracking-widest border-b border-black dark:border-white/30 pb-2 mb-2 text-black dark:text-white flex items-center justify-between">
              <span>Section 1: Operator Core Details</span>
              <span className="text-red-600 dark:text-red-400">[REQ]</span>
            </div>

            <div>
              <label
                htmlFor="name"
                className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2"
              >
                Full Designation*
              </label>
              <input
                type="text"
                name="name"
                id="name"
                required
                onChange={handleChange}
                placeholder="First Last"
                className="w-full px-4 py-3 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] placeholder-gray-400 dark:placeholder-gray-500 text-black dark:text-white font-mono focus:outline-none focus:ring-0 focus:bg-gray-50 dark:focus:bg-[#1a1a1a] transition-all sm:text-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2"
              >
                Email*
              </label>
              <input
                type="email"
                name="email"
                id="email"
                required
                onChange={handleChange}
                placeholder="user@domain.com"
                className="w-full px-4 py-3 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] placeholder-gray-400 dark:placeholder-gray-500 text-black dark:text-white font-mono focus:outline-none focus:ring-0 focus:bg-gray-50 dark:focus:bg-[#1a1a1a] transition-all sm:text-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2"
              >
                Security Key*
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  required
                  onChange={handleChange}
                  placeholder="••••••••"
                  minLength={6}
                  className="w-full px-4 py-3 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] placeholder-gray-400 dark:placeholder-gray-500 text-black dark:text-white font-mono focus:outline-none focus:ring-0 focus:bg-gray-50 dark:focus:bg-[#1a1a1a] transition-all sm:text-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-1 pr-4 flex items-center text-black dark:text-white bg-transparent border-none hover:text-red-600 dark:hover:text-red-400"
                >
                  {showPassword ? (
                    <FaEyeSlash className="h-4 w-4" />
                  ) : (
                    <FaEye className="h-4 w-4" />
                  )}
                </button>
              </div>
            </div>

            <div>
              <label
                htmlFor="gender"
                className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2"
              >
                Classification*
              </label>
              <select
                name="gender"
                id="gender"
                required
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] text-black dark:text-white font-mono focus:outline-none focus:ring-0 focus:bg-gray-50 dark:focus:bg-[#1a1a1a] transition-all sm:text-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
              >
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="md:col-span-2 text-xs font-mono font-black uppercase tracking-widest border-b border-black dark:border-white/30 pb-2 mt-4 mb-2 text-black dark:text-white flex items-center justify-between">
              <span>Section 2: Physical Coordinates</span>
              <span className="text-gray-500 dark:text-gray-400">[ADD]</span>
            </div>

            <div className="md:col-span-2">
              <label
                htmlFor="street"
                className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2"
              >
                Street*
              </label>
              <input
                type="text"
                name="street"
                id="street"
                required
                onChange={handleChange}
                placeholder="123 Sector Block"
                className="w-full px-4 py-3 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] placeholder-gray-400 dark:placeholder-gray-500 text-black dark:text-white font-mono focus:outline-none focus:ring-0 focus:bg-gray-50 dark:focus:bg-[#1a1a1a] transition-all sm:text-sm shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
              />
            </div>

            <div>
              <label className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2">
                City*
              </label>
              <input
                type="text"
                name="city"
                required
                onChange={handleChange}
                className="w-full px-4 py-3 border border-black dark:border-white/30 bg-white dark:bg-[#111] text-black dark:text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1 transition-all"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2">
                  State*
                </label>
                <input
                  type="text"
                  name="state"
                  required
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-black dark:border-white/30 bg-white dark:bg-[#111] text-black dark:text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1 transition-all"
                />
              </div>
              <div>
                <label className="block text-xs font-bold font-mono tracking-widest uppercase text-black dark:text-white mb-2">
                  Zip/Pincode*
                </label>
                <input
                  type="text"
                  name="pincode"
                  required
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-black dark:border-white/30 bg-white dark:bg-[#111] text-black dark:text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1 transition-all"
                />
              </div>
            </div>

            <div className="md:col-span-2 text-xs font-mono font-black uppercase tracking-widest border-b border-black dark:border-white/30 pb-2 mt-4 mb-2 text-black dark:text-white flex items-center justify-between">
              <span>Section 3: Remote Networks</span>
              <span className="text-gray-500 dark:text-gray-400">[OPT]</span>
            </div>

            <div className="md:col-span-2">
              <select
                name="social"
                onChange={(e) => setSocial(e.target.value === "1")}
                className="w-full px-4 py-3 rounded-none border border-black dark:border-white/30 bg-white dark:bg-[#111] text-black dark:text-white font-mono focus:outline-none focus:ring-0 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] focus-visible:shadow-none dark:focus-visible:shadow-none focus-visible:translate-x-1 focus-visible:translate-y-1"
              >
                <option value="0">Skip Socials (Optional)</option>
                <option value="1">Add Socials (Optional)</option>
              </select>
            </div>

            {social && (
              <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-4 p-4 border border-black dark:border-white/30 bg-[#f4f4f4] dark:bg-[#1a1a1a] mt-2 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)]">
                <div>
                  <label className="block text-[11px] tracking-wide font-mono font-bold uppercase mb-1 text-black dark:text-white">
                    X-Network
                  </label>
                  <input
                    name="twitter"
                    onChange={handleChange}
                    className="w-full px-2 py-2 border border-black dark:border-white/30 bg-white dark:bg-black text-black dark:text-white text-xs"
                  />
                </div>
                <div>
                  <label className="block text-[11px] tracking-wide font-mono font-bold uppercase mb-1 text-black dark:text-white">
                    Instagram
                  </label>
                  <input
                    name="instagram"
                    onChange={handleChange}
                    className="w-full px-2 py-2 border border-black dark:border-white/30 bg-white dark:bg-black text-black dark:text-white text-xs"
                  />
                </div>
                <div>
                  <label className="block text-[11px] tracking-wide font-mono font-bold uppercase mb-1 text-black dark:text-white">
                    Linked In
                  </label>
                  <input
                    name="linked_in"
                    onChange={handleChange}
                    className="w-full px-2 py-2 border border-black dark:border-white/30 bg-white dark:bg-black text-black dark:text-white text-xs"
                  />
                </div>
              </div>
            )}

            <div className="md:col-span-2 mt-8">
              <button
                type="submit"
                className="w-full py-4 px-4 border border-black dark:border-white/30 text-sm font-black font-mono tracking-widest uppercase text-white dark:text-black bg-black dark:bg-white hover:bg-white hover:text-black dark:hover:bg-black dark:hover:text-white transition-colors shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none active:translate-x-0.5 active:translate-y-0.5"
              >
                Compile Identity
              </button>
            </div>

            <p className="md:col-span-2 mt-4 text-center text-[10px] font-mono tracking-widest uppercase font-bold text-gray-500 dark:text-gray-400">
              Already initialized?{" "}
              <Link
                to="/login"
                className="text-black dark:text-white border-b border-black dark:border-white/30 hover:text-red-600 dark:hover:text-red-400 transition-colors ml-2"
              >
                Access Dashboard
              </Link>
            </p>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Signup;
